<template>
  <select :name="name" :id="name" class="form-control" style="width: 100%" :placeholder="placeholder" :disabled="disabled"></select>
</template>

<script>
  import 'selectize'
  import '@/assets/js/dropdown_direction'
  import '@/assets/js/disable_delete'
  import $ from 'jquery'
  import _ from 'lodash'

  export default {
    props: {
      name: {
        required: true,
        type: String
      },
      options: {
        required: true,
        type: Array
      },
      groups: {
        required: false,
        type: Array
      },
      value: {
        required: false,
        default: null
      },
      placeholder: {
        required: false,
        default: ' '
      },
      allowNewOptions: {
        required: false,
        type: Boolean,
        default: false
      },
      onNewOption: {
        required: false,
        type: Function
      },
      searchable: {
        required: false,
        type: Boolean,
        default: true
      },
      disabled: {
        required: false,
        type: Boolean,
        default: false
      },
      renderOption: {
        required: false,
        type: Function
      },
      fetchResults: {
        required: false,
        type: Function
      },
      disableDelete: {
        required: false,
        type: Boolean,
        default: false
      },
      preLoad: {
        required: false,
        default: false
      },
      valueField: {
        required: false,
        default: 'id'
      }
    },

    data () {
      return {
        element: null,
        selectize: null
      }
    },

    mounted () {
      this.element = $(this.$el)

      this.bind()
    },

    watch: {
      /**
       * Watch the disabled prop for changes and refresh the picker.
       *
       * @return void
       */
      disabled (disabled) {
        this.toggleDisabled(disabled)
      },

      /**
       * Watch the options for changes and refresh the picker.
       *
       * @return void
       */
      options: {
        handler (newOptions, oldOptions) {
          if (_.isEqual(newOptions, oldOptions)) {
            return
          }

          let value = this.value

          this.selectize.clearOptions()

          _.each(this.groups, group => {
            this.selectize.addOptionGroup(group.id, group)
          })

          this.selectize.addOption(_.cloneDeep(newOptions))
          this.selectize.refreshOptions(false)

          this.selectize.setValue(value, false)
        },
        deep: true
      },

      /**
       * Watch the parent v-model for any changes any have them reflected on the
       * select picker. Allows programatic selection.
       *
       * @param mixed value
       *
       * @return void
       */
      value (value) {
        this.selectize.$dropdown.find('.selected').not('.active').removeClass('selected')

        this.selectize.setValue(value, true)
      }
    },

    methods: {
      /**
       * Bind the selectize element.
       *
       * @return void
       */
      bind () {
        this.selectize = this.element.selectize({
          plugins: ['dropdown_direction', 'disable_delete'],
          dropdownDirection: 'auto',
          dropdownParent: 'body',
          optgroups: _.cloneDeep(this.groups),
          options: _.cloneDeep(this.options),
          optgroupField: 'group',
          optgroupLabelField: 'text',
          optgroupValueField: 'id',
          labelField: 'text',
          valueField: this.valueField,
          highlight: false,
          disableDelete: this.disableDelete,
          create: this.onNewOption === undefined ? false : (input, callback) => {
            if (this.onNewOption) {
              this.onNewOption(input).then(callback)
            }
          },
          createFilter: input => {
            return _.find(this.options, option => option.text.toLowerCase() === input.toLowerCase()) === undefined
          },
          onChange: this.handleChanged,
          onDropdownClose: dropdown => {
            $(dropdown).find('.selected').not('.active').removeClass('selected')
          },
          render: {
            option: this.renderOption || ((item, escape) => {
              return `<div class="option">${item.text}</div>`
            }),
            item: (data, escape) => {
              return `<div class="item">${data[this.selectize.settings.labelField]}</div>`
            }
          },
          load: this.fetchResults || null,
          preload: this.preLoad,
          score: search => {
            let score = this.selectize.getScoreFunction(search)

            return function (item) {
              if (item.id === null || item.id === undefined || item.id === '') {
                return 0
              }

              return score(item)
            }
          }
        })[0].selectize

        this.selectize.setValue(this.value)

        this.toggleDisabled(this.disabled)
      },

      /**
       * Toggle disabled.
       *
       * @param boolean disabled
       *
       * @return void
       */
      toggleDisabled (disabled) {
        if (disabled) {
          this.selectize.disable()
        } else {
          this.selectize.enable()
        }

        this.selectize.setValue(this.value, true)
      },

      /**
       * Clears the selected input.
       *
       * @return void
       */
      clear () {
        this.selectize.clear()

        this.$emit('input', null)
      },

      /**
       * Handle the changed event, emits the input value up to the parent component.
       *
       * @return void
       */
      handleChanged (value) {
        this.$emit('input', this.shouldBeNumber(value))
      },

      /**
       * Converts value to a number if it should be a number.
       *
       * For strict type comparisons.
       *
       * @param mixed value
       *
       * @return mixed
       */
      shouldBeNumber (value) {
        if (value === null || value === '') {
          return null
        }

        let number = _.toNumber(value)

        if (_.isNaN(number)) {
          return value
        }

        return number
      },

      /**
       * Determine if value is out of bounds of options.
       *
       * @param mixed value
       * @param array options
       *
       * @return boolean
       */
      isValueOutOfBounds (value, options) {
        return _.filter(options, option => option.id === value).length === 0
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Selectize.vue?607f5fba